import { render, staticRenderFns } from "./HelpdeskSettings.vue?vue&type=template&id=815352dc&scoped=true&"
import script from "./HelpdeskSettings.vue?vue&type=script&lang=js&"
export * from "./HelpdeskSettings.vue?vue&type=script&lang=js&"
import style0 from "./HelpdeskSettings.vue?vue&type=style&index=0&id=815352dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815352dc",
  null
  
)

export default component.exports